"use client";

import { CartIcon } from "../lifestyleIcons";

interface AddToCartButtonProps {
  /** Used to label the button for screen readers. */
  prizeName: string;
  isDisabled?: boolean;
  onClick: () => void;
}

export default function AddToCartButton({ prizeName, isDisabled = false, onClick }: AddToCartButtonProps) {
  return (
    <button
      type="button"
      disabled={isDisabled}
      onClick={event => {
        event.stopPropagation();
        onClick();
      }}
      aria-label={`Add a ${prizeName} ticket to your basket`}
      className="flex items-center justify-center shrink-0 w-10 h-10 text-white bg-primary rounded transition-colors hover:bg-primary/90 disabled:opacity-38 disabled:cursor-not-allowed">
      {/* Icon frame 20×21; vector leaf ~15×16.5 as in Figma */}
      <CartIcon className="w-[14.83px] h-[16.5px]" />
    </button>
  );
}
